import { render, staticRenderFns } from "./api-key-form.vue?vue&type=template&id=15b33e28&scoped=true"
import script from "./api-key-form.vue?vue&type=script&lang=js"
export * from "./api-key-form.vue?vue&type=script&lang=js"
import style0 from "./api-key-form.vue?vue&type=style&index=0&id=15b33e28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b33e28",
  null
  
)

export default component.exports